export default __webpack_public_path__ + "static/media/group-person-icon.fe7865c7.svg";